import COLORS from '@/constants/colors';

export const headerCellStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: COLORS.olive,
};

export const productNameStyle = {
  fontSize: '12px',
  fontWeight: '500',
  color: COLORS.gray_800,
};
export const productPresentationStyle = {
  fontSize: '12px',
  fontWeight: '500',
  color: COLORS.gray_500,
};
export const productPricingStyle = {
  fontSize: '12px',
  fontWeight: '500',
  color: COLORS.gray_700,
};

export const subTitleStyle = {
  fontSize: '12px',
  fontWeight: 400,
  color: COLORS.mercanto_blue,
};

export const subSectionStyle = {
  fontSize: '14px',
  fontWeight: 600,
  color: COLORS.mercanto_blue,
};

export const fieldStyle = {
  fontSize: '12px',
  fontWeight: '500',
  color: COLORS.blackish,
};

export const dividerStyle = {
  width: '100%',
  height: '1px',
  backgroundColor: COLORS.gray_6,
  border: 'none',
};

export const cancelOrderStyle = {
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 500,
  textDecorationLine: 'underline',
  textDecorationStyle: 'solid',
  textAlign: 'end',
  mt: '32px',
  cursor: 'pointer',
};
